import PropTypes from 'prop-types';
import React from 'react';
import S from '../../../screens/main/screens/phases/shared/modal.scss';
import {} from 'actionCreators/phase';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import FlagType from 'types/flag';
import styles from './styles.scss';

class SendEstimatorAPEmailModal extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleSubmit(week) {
    this.props.sendEmail(week);
    this.handleClose();
  }

  handleClose() {
    this.props.onClose();
  }

  render() {
    return (<Dialog
      active={this.props.active}
      className={`${S.modal} ${styles.seeBtnModalStyles}`}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>Send Estimator AP Email</h5>
      <Button
        label="Current Week"
        flat inverse ripple
        className={`${S.submit} ${styles.seeBtnModalHover}`}
        onClick={() => this.handleSubmit('current')}
      />
      <Button
        label="Previous Week"
        flat inverse ripple
        className={`${S.submit} ${styles.seeBtnModalHover}`}
        onClick={() => this.handleSubmit('previous')}
      />
    </Dialog>);
  }
}

SendEstimatorAPEmailModal.propTypes = {
  errors: PropTypes.object,
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  clearValidation: PropTypes.func.isRequired,
  sendEmail: PropTypes.func,
  flag: FlagType,
};

export default SendEstimatorAPEmailModal;



// WEBPACK FOOTER //
// ./client/app/shared/components/EstimatorAPButton/sendEstimatorAPEmailModal.jsx